/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BlockchainResponseDashboardDto } from '../../models/blockchain-response-dashboard-dto';

export interface DashboardBlockchainsControllerListBlockchainsV1$Params {

/**
 * Optional search string for filtering blockchains
 */
  search?: string;
}

export function dashboardBlockchainsControllerListBlockchainsV1(http: HttpClient, rootUrl: string, params?: DashboardBlockchainsControllerListBlockchainsV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BlockchainResponseDashboardDto>>> {
  const rb = new RequestBuilder(rootUrl, dashboardBlockchainsControllerListBlockchainsV1.PATH, 'get');
  if (params) {
    rb.query('search', params.search, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BlockchainResponseDashboardDto>>;
    })
  );
}

dashboardBlockchainsControllerListBlockchainsV1.PATH = '/v1/dashboard/blockchains';
